import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs/operators';

export const homeGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  // Wait for authentication initialization to complete before checking status
  return authService.getAuthenticationStatus().pipe(
    map(isAuthenticated => {
      if (isAuthenticated) {
        // User is authenticated, redirect to projects
        router.navigate(['/projects']);
        return false;
      }

      // User is not authenticated, allow access to home page
      return true;
    })
  );
};
